export enum PaymentTermsEnum {
    LC_AT_SIGHT = "001-LC At Sight",
    CREDIT_15_DAYS = "002-Credit 15 days",
    CREDIT_30_DAYS = "003-Credit 30 Days",
    CREDIT_60_DAYS = "004-Credit 60 days",
    CREDIT_90_DAYS = "005-Credit 90 days",
    CREDIT_120_DAYS = "006-Credit 120 days",
    PAY_ON_DELIVERY = "007-Payt on Deliver",
    A_008_ADVANCE_100_PERCENT = "008-100% Advance",
    A_009_ADVANCE_10_PERCENT_BALANCE_ON_DELIVERY = "009-10% Adv 90% De",
    A_010_ADVANCE_20_PERCENT_BALANCE_ON_DELIVERY = "010-20% Adv 80% De",
    A_001_ADVANCE_25_PERCENT_BALANCE_ON_DELIVERY = "011-25% Adv 75% De",
    A_012_ADVANCE_50_PERCENT_BALANCE_ON_DELIVERY = "012-50%Adv50%Delive",
    LC_15_DAYS = "013-LC 15 days",
    LC_30_DAYS = "014-LC 30 Days",
    LC_60_DAYS = "015-LC 60 days",
    LC_90_DAYS = "016-LC 90 days",
    LC_180_DAYS = "017-LC 180 days",
    DP_AT_SIGHT = "018-DP AT SIGHT",
    CREDIT_35_DAYS = "019-Credit 35 Days",
    AGAINST_COMMERCIAL_INVOICE = "020-Agnst Comm. Inv",
    CREDIT_45_DAYS = "021-Credit 45 Days",
    TT_25_DAYS = "022-TT 25 Days",
    CREDIT_7_DAYS = "023-Credit 7 days",
    CASH_ON_DELIVERY = "024-Cash on Deliver",
    DP_15_DAYS_AIR = "025-DP 15 days(Air)",
    DP_30_DAYS_SEA = "026-DP 30days(Sea)",
    ADVANCE_AGAINST_PI = "027-Adv Agnst PI",
    ADVANCE_90_PERCENT = "028-90% Advance",
    DEQ_30_DAYS = "029-DEQ-30 Days",
    TRADE_CARD_30_DAYS = "030-Trde Card30 Day",
    TRADE_CARD_45_DAYS = "031-Trde Card45 Day",
    ADVANCE_30_PERCENT_BALANCE_ON_DELIVERY = "032-30% Adv 70% De",
    A_033LC45dayAtSight = '033-LC45dayAt Sight',
    A_034LC90dayfrShipm = '034-LC90dayfr Shipm',
    A035C60dayAtSight='035-LC60dayAt Sight',
    A_036LC30dayAtSight = '036-LC30dayAt Sight',
    A_03740Adv60De ='037-40% Adv 60% De',
    A_038DA45Days = '038-DA 45 Days',
    A_039LC15dayAtSight = '039-LC15dayAt Sight',
    A_04080ADVANCE = '040-80%ADVANCE',
    A_041PDC15days = '041-PDC 15 days',
    A_042LC25dayAtSight='042-LC25dayAt Sight',
    A_043TT20Days = '043-TT  20 Days',
    A_04435Adv65De= '044-35% Adv 65% De',
    A_045TrdCard22days = '045-Trd Card 22days',
    A_046PDC30Days = '046-PDC 30 Days',
    A_047PDC60Days = '047-PDC 60 Days',
    A_048TT15DAYS=  '048-TT 15 DAYS',
    A_049CREDIT30DAYS = '049-CREDIT 30 DAYS',
    A_050CREDIT25DAYS = '050-CREDIT 25 DAYS',
    A_051PDC45Days = '051-PDC 45 Days',
    A_052TT30DAYS = '052-TT 30 DAYS',
    A_053FOC= '053-FOC',
    A_05460ADVANCE = '054-60%ADVANCE',
    A_055LC55dayAtSight = '055-LC55dayAt Sight',
    A_056LC30dayFromLR = '056-LC30 day FromLR',
    A_057LC30DaysfrDA = '057-LC30 Days fr DA',
    A_058TT45days = '058-TT 45 days',
    A_059PDC7Days = '059-PDC 7 Days',
    A_060LC35dayFromLR = '060-LC35 day FromLR',
    A_06130daysfromP = '061-30 days from  P',
    A_062DP60daysSea= '062-DP 60days(Sea)',
    A_063TT75Days = '063-TT  75 Days',
    A_06425AdvBal15 = '064-25% Adv Bal 15',
    A_065Credit20days = '065-Credit 20 days',
    A_06615daysPDCat = '066-15 days PDC at',
    A_06721daysPDCat = '067-21 days PDC at',
    A_06825daysPDCat = '068-25 days PDC at',
    A_069ILC21Days = '069-ILC 21 Days',
    A_07Credit150days = '07-Credit 150 days',
    A_070PDC10Days = '070-PDC 10 Days',
    A_07120TTAdv80= '071-20% TT Adv &80%',
    A_072LC21Days = '072-LC 21 Days',
    A_07310AdvbalPI = '073-10% Adv bal. PI',
    A_074LC60Daysfro = '074- LC 60 Days fro',
    A_075DA90days = '075-DA 90 days',
    A_076LC37dayFromLR = '076-LC37 dayFrom LR',
    A_07735DAYSFROMBE = '077-35 DAYS FROM BE',
    A_07830Adv70LC = '078-30% Adv & 70%LC',
    A_079Credit10days= '079-Credit 10 days',
    A_080LC70dayssig = '080-LC  70 days sig',
    A_081TT90Days = '081-TT  90 Days',
    A_082TT60Days = '082-TT  60 Days',
    A_08310DAYSPDCFRO ='083-10 DAYS PDC FRO',
    A_084Tradecardsigh = '084-Trade card sigh',
    A_08585adv15LR = '085-85% adv 15% LR',
    A_086LC45DAYS = '086-LC-45 DAYS',
    A_087LC0days = '087-LC- 40 days',
    A_088LC40DAYSFROM = '088-LC 40 DAYS FROM',
    A_089LC120DayNego = '089-LC 120 Day Nego',
    A_09050Advance = '090-50% Advance',
    A_09150advbalon30d = '091-50%advbal on30d',
    A_09250adbal15dcr = '092-50%adbal15dcr',
    A_093PD25Dysfro = '093-PDC 25 Days fro',
    A_094OpnAc40Day = '094-Open A/c 40 Day',
    A_09550advbal25dcr = '095-50%adv&bal25dcr',
    A_096TTSIGHT= '096-TT SIGHT',
    A_09750advanceand = '097-50% advance and',
    A_09840adPO50de10 = '098-40%adPO50%de10%',
    A_09930ad70Pdc30dy = '099-30%ad70%Pdc30dy',
    A_100DA60days = '100-DA 60 days',
    A_10130adbalcd30 = '101-30%ad bal cd 30',
    A_102Lc90DaysSigh = '102-Lc 90 Days Sigh',
    A_103AgCIwith125d = '103-AgtCIwith1.25%d',
    A_104DA360days = '104-DA 360 days',
    A_105PDdfminvoi = '105-PDC 7d fm invoi',
    A_106PD30dfminvo = '106-PDC 30d fm invo',
    A_10730DaysDPStg = '107-30 Days DP Stg',
    A_10815Advance = '108-15%Advance',
    A_109PD40Days = '109-PDC 40 Days',
    A_11050adBl50CI = '110-50%ad,Bl 50% CI',
    A_11120Adv80 = '111-20% Adv 80%',
    A_11220Adv755 = '112-20% Adv 75%, 5%',
    A_11375Adv25Delive = '113-75%Adv25%Delive',
    A_11410Adv8010 = '114-10% Adv 80%-10%',
    A_11520Adv6020 = '115-20% Adv 60%-20%',
    A_11675Advbaloni = '116-75%Adv.bal on i',
    A_11785advbalond = '117-85%adv bal on d',
    A_11825adv6510 = '118-25%adv,65%,10%',
    A_11910Adv855 = '119-10%Adv,85%,5%',
    A_12030adv70PI = '120-30%adv.70% PI',
    A_12110adv855 = '121-10%adv,85%,5%',
    A_122TTINADVANCE = '122-TT IN ADVANCE',
    A_12310Adv7020 = '123-10%Adv,70%,20%',
    A_12425ADV75AGP = '124-25%ADV,75%AG P',
    A_12525Advbalonp = '125-25&Adv.bal on p',
    A_127AsperPOterms = '127-As per PO terms',
    A_12830adbalcd15 = '128-30%ad bal cd 15',
    A_12920Adv75Cer5 = '129-20%Adv,75%Cer,5',
    A_130DP10DAYS = '130-DP 10 DAYS',
    A_13115dPDCfmInvo = '131-15d PDC fm Invo',
    A_13290DAYSFRMIC = '132-90 DAYS FRM IC',
    A_13390DAYSFRMIC = '133-90 DAYS FRM IC',
    A_134Lc45DysfrLR = '134-Lc 45 Dys fr LR',
    A_13520Adv60Agt = '135-20% Adv 60% Agt',
    A_136OpenAc75Day = '136-Open A/c 75 Day',
    A_13730ad70pdc45 = '137-30%ad 70%pdc 45',
    A_138CHEQUE = '138-CHEQUE',
    A_13975Dysfrominv = '139-75 Dys from inv',
    A_140TT07Days = '140-TT 07 Days',
    A_141NA = '141-NA',
    A_14235daysPDCat = '142-35 days PDC at',
    A_1432CDagainstd = '143-2% CD against d',
    A_144Within3daysa = '144-Within 3 days a',
    A_145Within3Dmater = '145-Within 3D mater',
    A_146PDC21Days = '146-PDC 21 Days',
    A_1471CD100adv = '147-1% CD 100% adv',
    A_14810advbal15 = '148-10% adv, bal 15',
    A_149LC30dayfrmBL = '149-LC30 day frm BL',
    A_150PDC10Days = '150-PDC 10 Days',
    A_160120DaysfromF = '160-120 Days from F',
    A_161TT15dayDOI = '161-TT 15 days-DOI',
    A_162TT14DAYS = '162-TT 14 DAYS',
    A_163DPE75DAYS = '163-DPE 75 DAYS',
    A_164LC30daysBE = '164-LC 30 days-BE',
    A_165Landed = '165-Landed',
    A_16630daysopenac = '166-30 days open ac',
    A_167TradeCard60Day = '167-TradeCard 60Day',
    A_168PDC45DOI = '168-PDC 45 DOI',
    A_169120DysFrShip = '169-120 Dys Fr Ship',
    A_170LC29DAYS = '170-LC29 DAYS',
    A_17120adv80LC = '171-20%adv & 80% LC',
    A_172Credit12days = '172-Credit 12 days',
    A_173LcSightTTad = '173-L/c Sight/TT ad',
    A_174ACIwith2dis = '174-ACI with 2% dis',
    A_175ACIwith175di = '175-ACI with1.75%di',
    A_17630Daysfmnegot = '176-30Days fm negot',
    A_177RTGS7days125 = '177-RTGS7days-1.25%',
    A_178TT60dayEndMonth = '178-TT60dayEndMonth',
    A_17980POD20  = '179-80% POD & 20 %',
    A_18sance35Days = '18-Usance 35 Days',
    A_180LCAtSightT = '180-LC At Sight & T',
    A_181FOC = '181-FOC',
    A_18270LC30TT = '182-70% LC / 30 %TT',
    A_183PDC30daysagPI = '183-PDC30days ag PI',
    A_18450AdvBalPI = '184-50% Adv Bal PI',
    A_18530TT70DPSIGH = '185-30%TT70%DP SIGH',
    A_186DA30days = '186-DA-30 days',
    A_18775adv25OrdCo = '187-75%adv25%Ord Co',
    A_18880DPSIGHT20TT = '188-80%DPSIGHT20%TT',
    A_189OPENACCOUNT90 = '189-OPEN ACCOUNT 90',
    A_190PDC15daysagPI = '190-PDC15days ag PI',
    A_191LC150days = '191-LC 150 days',
    A_192AdvPmtofGrei = '192-Adv Pmt of Grei',
    A_19365daysfromsh = '193-65 days from sh',
    A_194CREDIT30DAYS = '194-CREDIT 30 DAYS',
    A_195RTGS5days = '195-RTGS 5 days',
    A_19736Adv64De = '197-36% Adv 64% De',
    A_19873Adv27De = '198-73% Adv 27% De',
    A_199ADVPI1CD = '199-ADV-PI 1%CD',
    A_2019030DGRN10BG = '201-90% 30DGRN10%BG',
    A_20250advbalPDC = '202-50%advbal PDC',
    A_20370Adv30after = '203-70%Adv30%after',
    A_204110fromShpmen = '204-110 from Shpmen',
    A_205LC21dayFromLR = '205-LC21 day FromLR',
    A_206LC15dayFromLR = '206-LC15 day FromLR',
    A_209TT120Days = '209-TT 120 Days',
    A_210DA120days = '210-DA 120 days',
    A_211LC60dayFromLR = '211-LC 60 dayFromLR',
    A_212CREDIT75DAYS = '212-CREDIT 75 DAYS',
    A_213PDC90days = '213-PDC 90 days',
    A_214DA30daysfrom = '214-DA 30 days from',
    A_215DP90days = '215-DP 90 days',
    A_216LC120days = '216-LC 120 days',
    A_21721DaysCredit = '217-21 Days Credit',
    A_218OPENACCOUNT120 = '218-OPEN ACCOUNT120',
    A_219EOM63= '219-EOM+63',
    A_22060DAYSPDCFRO = '220-60 DAYS PDC FRO',
    A_22125advbal10g = '221-25%adv bal 10 g',
    A_222175daysGRN = '222-175 days GRN',
    A_223CREDIT180DAYS = '223-CREDIT 180 DAYS',
    A_224CREDIT120DAYS = '224-CREDIT 120 DAYS',
    A_225CREDIT90DAYS = '225-CREDIT 90 DAYS',
    A_22630AdvancePI = '226-30% Advance PI',
    A_227120daysPDC = '227-120 days PDC',
    A_228CREDIT100DAYS = '228-CREDIT 100 DAYS',
    A_22950daysPDC = '229-50 days PDC',
    A_23065AdvagPI = '230-65%Adv ag PI',
    A_231DP15days = '231-DP 15 days',
    A_232LC7days = '232-LC 7 days',
    A_233150DaysBLAW = '233-150 Days BL/AW',
    A_234Within90days = '234-Within 90 days',
    A_235LC90TT10 = '235-LC 90% TT 10%',
    A_236LC15DfromLR = '236-LC 15D from LR',
    A_237TTopenac105 = '237-TT open a/c 105',
    A_23830DaysNet = '238-30 Days Net',
    A_239Net20DaysROG = '239-Net 20 Days ROG',
    A_240DP20days = '240-DP 20 days',
    A_241CRD30DINVDT = '241-CRD 30D INV DT',
    A_242AgainstDispatc = '242-Against Dispatc',
    A_243CREDIT60INV = '243-CREDIT 60 - INV',
    A_244LC15daysBE = '244-LC 15 days-BE',
    A_245OPENACCOUNT100 = '245-OPEN ACCOUNT100',
    A_93OPENAc60DAY = '93-OPEN A/c 60 DAY',
    A_NANA = 'NA-NA',


}